<template>
    <card v-bind="cardProps" class="z-1 border-t-2 border-gray-300">
            <aspect-ratio-box ratio="1" class="relative">
                <skeleton width="100%" height="100%"/>
            </aspect-ratio-box>
        <div class="flex flex-column items-start px-12 md:px-16 py-8 md:py-12 w-full overflow-x-hidden">
            <div class="flex w-full overflow-x-hidden mt-2">
                <skeleton rounded width="50" height="11" class="mr-8"/>
                <skeleton rounded width="70" height="11"/>
            </div>

            <skeleton rounded width="90" height="12" class="mt-4 mb-6"/>

            <skeleton rounded height="10" class="w-full mb-3"/>
            <skeleton rounded height="10" width="100" class="mb-2"/>

        </div>
    </card>
</template>

<script>
import CardMixin from "../Card/CardMixin";

export default {
    name: "UserCardSkeleton",

    mixins: [CardMixin],
}
</script>